(function($){
    $(document).ready(function(){
        if($('.over-menu').length > 0){
            $('.over-menu > ul').addClass('categ-menu');
        }
        if($('.variations-special').length > 0){
            $('.variations-special tr').each(function(){
                $(this).find('.variant-setter').hide();
                var th = $(this);
                setTimeout(function(){
                    $('select#' + th.attr('data-variant-name')).find('option').each(function(){
                        th.find('.variant-setter[data-value="'+$(this).attr('value')+'"]').fadeIn(500);
                    })
                }, 700);
            });
        }
    });

    $('body').on('click', '.qib-button', function(){
        $('[name="update_cart"]').removeAttr('disabled');
    });

    if($('.sidebar-category-menu').length > 0) {
        $('.sidebar-category-menu ul li').each(function(){
            if($(this).find('.sub-menu')){
                $(this).addClass('has-sub-menu');
                $('<span class="arrow" />').insertBefore($(this).find('.sub-menu').first());
            }
        })
    }
    if($('#number-custom').length > 0) {
        var numberInput = document.getElementById("number-custom");

        numberInput.addEventListener("keydown", function (event) {
            var maxLength = 2; // maksymalna liczba znaków
            if (numberInput.value.length >= maxLength && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'Tab') {
                event.preventDefault();
            }
        });
    }
    $('body').on('keydown keyup change', '#sign-custom', function(){
        if($('.excluded-words').length > 0) {
            var words = $('.excluded-words').text().split('').reverse().join('').split(',');
            var sign = $('#sign-custom').val().toLowerCase();
            var lock = false;
            // if(words.indexOf(sign) > -1){
            //     $('.single_add_to_cart_button').hide();
            // }
            // else{
            //     $('.single_add_to_cart_button').show();
            // }
            $.each(words, function (index, word) {
                // console.log(word + ': ' + sign.search(word));
                if (sign.search(word) !== -1) {
                    lock = true;

                }
            });
            if (lock) {
                $('[name="add-to-cart"], .atc, .single_add_to_cart_button').hide();
            } else {
                $('[name="add-to-cart"], .atc, .single_add_to_cart_button').show();
            }
        }
    });
    $('.customization .tabs .exists').on('click', function(){
        if($('.atc').hasClass('lock-by-word')) {
            $('.atc').removeClass('lock-by-word');
            $('.atc').addClass('tmp-lock-by-word');
        }
    });
    $('.customization .tabs .custom').on('click', function(){
        if($('.atc').hasClass('tmp-lock-by-word')){
            $('.atc').addClass('lock-by-word');
            $('.atc').removeClass('tmp-lock-by-word');
        }
    });

    $('body').on('click', '.atc.lock-by-word', function(e){
        e.preventDefault();
        alert('Napis lub jego część na koszulce zawiera niedozwolone słowo');
    })


})(jQuery);